import React from "react";

// Components
import CustomTitle from "../../../components/CustomTitle";
import CustomParagraph from "../../../components/CustomParagraph";

const StepsHeading = ({ heading, text, fontSize, textFontSize }) => {
  return (
    <>
      <CustomTitle
        text={heading}
        fontSize={fontSize || "28px"}
        fontWeight="700"
        marginBottom="8px"
        lineHeight="40px"
      />

      <CustomParagraph
        text={text}
        fontSize={textFontSize || "14px"}
        fontWeight="400"
        color="#000"
        lineHeight="24px"
      />
    </>
  );
};

export default StepsHeading;
